import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
} from 'chart.js';
import 'chartjs-plugin-style';
import { Box } from '@mui/material';
import { getScanHistoryChartData } from '../../../../services/scanHistoryApi';
import { classes } from './utils';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
);
const ScanDocumentChart = ({ organizationId }) => {
  const [chartData, setChartData] = useState(null);
  const getAllScanData = async () => {
    const Data = await getScanHistoryChartData(organizationId);
    if (Data) {
      setChartData(Data);
    } else {
      setChartData(null);
    }
  };

  useEffect(() => {
    getAllScanData();
  }, []);
  // const maxScan = chartData && Math.max(...chartData.Scans);

  const data = {
    labels: chartData
      ? chartData?.Months.map((month) => month.substring(0, 3))
      : [],
    datasets: [
      {
        label: 'Scans',
        data: chartData ? chartData?.Scans : [],
        backgroundColor: 'rgba(159, 119, 235, 1)',
        borderColor: 'rgba(159, 119, 235, 1)',
        borderWidth: 3,
        pointRadius: 0,
        pointHoverRadius: 6,
        pointHitRadius: 10,
        lineTension: 0.35,
        // pointStyle: "rectRot",
        // pointBorderColor: "black",
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      // tooltips: {
      //   shadowOffsetX: 3,
      //   shadowOffsetY: 3,
      //   shadowBlur: 10,
      //   shadowColor: 'rgba(0, 0, 0, 0.5)'
      // }
      tooltip: {
        display: true,
        enabled: true,
        displayColors: false,

        backgroundColor: 'rgba(255, 255, 255, 1)',
        // backgroundColor: "rgba(0, 0, 0, 0.2)",
        // shadow: "0px 0px 11px 4px red",
        padding: 15,
        titleAlign: 'center',
        titleColor: 'rgba(0, 0, 0, 1)',
        titleFont: { weight: '500', family: 'Heebo' },
        bodyAlign: 'center',
        bodyColor: 'rgba(0, 0, 0, 0.6)',
        bodyFont: { weight: '400', family: 'Heebo' },
        caretSize: 7,
        yAlign: 'bottom',
        borderWidth: 5,
        // shadowColor: "red",
        // borderColor: "rgba(0, 0, 0, 0.08)",
        // shadowBlur: 2,
        // borderBox: {
        //   display: true,
        //   color:"red",
        //   // dash: [2, 2],
        // },
      },
    },

    scales: {
      x: {
        display: true,
        border: {
          display: false,
          dash: [2, 2],
        },
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.14)',
          lineWidth: 1,
          drawTicks: false,
          // tickLength: 50,
          // tickColor: "red",
          drawBorder: true,
          drawOnChartArea: true,
        },
        title: {
          display: true,
          text: 'Plan Duration',
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
          padding: {
            top: 30,
          },
        },
        ticks: {
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
        },
        offset: true,
      },
      y: {
        display: true,
        border: {
          display: false,
          dash: [2, 2],
        },
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: 'No of Scan',
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
          padding: {
            bottom: 20,
          },
        },
        // max: 200,
        min: 0,
        ticks: {
          stepSize: 50,
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
        },
        offset: true,
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    },
  };

  return (
    <Box className={classes.scanHistoryChartBox}>
      {chartData && (
        <Line
          data={data}
          options={options}
          className={classes.scanHistoryChart}
        />
      )}
    </Box>
  );
};

ScanDocumentChart.defaultProps = {
  organizationId: undefined,
};

ScanDocumentChart.propTypes = {
  organizationId: PropTypes.string,
};

export default ScanDocumentChart;
